module.exports = __webpack_public_path__ + "images/income.a3da441cd5161901636a18c1669b6c88.svg";